export default __webpack_public_path__ + "static/media/moon-clear-line.6f50fbf9.svg";